import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
import { useProtectedContent } from "../../hooks/useProtectedContent";
// State Import
import { useMain } from "../../state/userMainState";
import { useStaffList } from "../../state/staffListState";
// Component imports
import { StaffTable } from "../../components/StaffTable";
import { StaffTableSearchBar } from "../../components/StaffTableSearchBar";
import { StaffListHeader } from "./StaffListHeader";

export function StaffList({ status }) {
  const [staffList, setStaffList] = useState({
    filter: {},
    paging: {},
    staff: [],
  });

  // Main Data
  const [mainData, setMainData] = useState({
    user: {},
    branches: [],
    bodyTypes: [],
    countries: [],
  });

  const canViewAllBranches = useProtectedContent("staffAllBranches");

  const [staffFilter, setStaffFilter] = useUrlFilterState(
    {
      status: status || "all",
      search: "",
      branchFilter: "Mine",
      myBranchesFilter: "All",
      page: 1,
      pageSize: 25,
    },
    {
      exclude: ["status", "pageSize"],
      sanitise: (state) => {
        // Prevent users without staffAllBranches from bypassing via URL
        if (!canViewAllBranches && state.branchFilter === "All") {
          return { ...state, branchFilter: "Mine" };
        }
        return state;
      },
    },
  );

  // Fetch Staff List
  const { isPending, isError, data, error, isFetching, isSuccess } =
    useStaffList(staffFilter);
  // Success Function
  const successFunc = () => setStaffList(data.data.data.data.list);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  // Fetch User Data
  const { data: dataMain, isSuccess: isSuccessMain } = useMain();
  // Success Function
  const successFunc2 = () => setMainData(dataMain.data.data.data.data);
  // Error Function
  const errorFunc2 = () =>
    console.warn(`Error: ${dataMain.data.status}: ${dataMain.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(
    isSuccessMain,
    dataMain,
    dataMain?.data?.status,
    successFunc2,
    errorFunc2,
  );

  const [selectedRows, setSelectedRows] = useState([]);

  // // Handle selected rows
  // const onRowSelectionHandler = (ids) => {
  //   setSelectedRows(ids);
  // };

  return (
    <>
      <StaffListHeader status={status} selectedRows={selectedRows} />
      {mainData.branches && mainData.branches.length !== 0 && (
        <StaffTableSearchBar
          userBranches={mainData.branches}
          staffFilter={staffFilter}
          setStaffFilter={setStaffFilter}
        />
      )}
      {isError && <span>Error: {error.message}</span>}
      {staffList.staff && staffList.staff.length !== 0 ? (
        <StaffTable
          data={staffList}
          loading={isFetching}
          // onRowSelectionHandler={onRowSelectionHandler}
          staffFilter={staffFilter}
          setStaffFilter={setStaffFilter}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
      ) : (
        !isPending && <p>No staff</p>
      )}
    </>
  );
}
